/*
 * SPDX-FileCopyrightText: 2023 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const createMutationObserver = (callback) => new MutationObserver(callback);

export { createMutationObserver as c };

//# sourceMappingURL=mutation-observer-db8757e6.js.map